module.exports = __webpack_public_path__ + "media/images/gm_icon04-13786c8a5ba6aa41f2f0dddb0f1e5fd1.png";